module.exports = __webpack_public_path__ + "img/bradescardLogo.d376bd00.png";